import request from '../utils/request'

export function searchAll(params) {
  return request.get('/api/search_all', { params })
}
